import axios from 'axios';
import { stripInvalidMbiChars } from '../functions/strip.invalid.mbi.chars';
import the from '../objects/the';
import use from '../objects/use';

const formatDateOfBirth = (dobObject) => {
    let {day, month, year} = dobObject;
    month = month.padStart(2, 0);
    day = day.padStart(2, 0);
    return [year, month, day].join('-');
};

const formatLastName = (lastName, suffix) => {
    return [lastName, suffix].join(' ').trim();
};

const formatSecretQuestionAnswer = (question, answer) => {
    return {
        challengeQuestionAndAnswers: [
            {
                question,
                answer,
            },
        ],
    };
};

export default function useForgotPasswordApi() {
    const tracker = use.inflightTracker;
   
    // Step 1
    const getSecretQuestion = async (userInfo) => {
        const url = '/reset-password/step/1';
        if (tracker.isAlreadyInflight(url))
            return;
        tracker.addApiCall(url);
        const {mbi, username, lastName, suffix, dateOfBirth} = userInfo;
        const data = {
            mbi: stripInvalidMbiChars(mbi),
            username,
            lastName: formatLastName(lastName, suffix),
            dateOfBirth: formatDateOfBirth(dateOfBirth)
        };
      
        try {
            const res = await axios.post(process.env.REACT_APP_API_ENDPOINT + url, data, {headers: the.defaultHeader});
            tracker.removeApiCall(url);
            return res.data.challengeQuestion;
        } catch (e) {
            tracker.removeApiCall(url);
            if (e.response) {
                throw e.response.data; // throw error response from SLS
            } else {
                throw e;
            }
        }
    };
   
    // Step 2
    const answerSecretQuestion = async (mbi, question, answer) => {
        const url = '/reset-password/step/2';
        if (tracker.isAlreadyInflight(url))
            return;
        tracker.addApiCall(url);
        const data = {
            mbi: stripInvalidMbiChars(mbi),
            ...formatSecretQuestionAnswer(question, answer)
        };
      
        try {
            await axios.post(process.env.REACT_APP_API_ENDPOINT + url, data, {headers: the.defaultHeader});
            tracker.removeApiCall(url);
        } catch (e) {
            tracker.removeApiCall(url);
            if (e.response) {
                throw e.response.data; // throw error response from SLS
            } else {
                throw e;
            }
        }
      
    };
   
    // Step 3
    const resetPassword = async (resetPasswordInfo) => {
        const url = '/reset-password/step/3';
        if (tracker.isAlreadyInflight(url))
            return;
        tracker.addApiCall(url);
        const {
            mbi,
            username,
            lastName,
            suffix,
            dateOfBirth,
            secretQuestion,
            secretAnswer,
            password
        } = resetPasswordInfo;
      
        const data = {
            mbi: stripInvalidMbiChars(mbi),
            username,
            lastName: formatLastName(lastName, suffix),
            dateOfBirth: formatDateOfBirth(dateOfBirth),
            newPassword: password,
   
            ...formatSecretQuestionAnswer(secretQuestion, secretAnswer)
        };
      
        try {
            await axios.post(process.env.REACT_APP_API_ENDPOINT + url, data, {headers: the.defaultHeader});
            tracker.removeApiCall(url);
        } catch (e) {
            tracker.removeApiCall(url);
            if (e.response) {
                throw e.response.data; // throw error response from SLS
            } else {
                throw e;
            }
        }
      
    };
   
    return {
        getSecretQuestion,
        answerSecretQuestion,
        resetPassword
    };
}